import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FeatureCard } from '@unmind/design-system';
import RoutePath from '../../../App/RoutePath';
import { tracking } from '../../../App/Tracking';

type Props = {
  source: string;
};

const MoodTrackerCTA = ({ source }: Props) => {
  const { t: translate } = useTranslation('track');

  const onCTAClick = () =>
    tracking.track('mood-tracker-cta-clicked', {
      source,
    });

  return (
    <FeatureCard
      titleAsChild
      description={translate('moods.checkin_cta.description')}
      icon={{
        name: 'arrow-right',
        variant: 'icon-button',
      }}
    >
      <Link to={RoutePath.CheckIn} onClick={onCTAClick}>
        {translate('moods.checkin_cta.title')}
      </Link>
    </FeatureCard>
  );
};

export default MoodTrackerCTA;
